import React from "react";

const SvgG = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="G_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#G_svg__a)">
      <path
        d="M58.09 160.93c2.72-.027 5.407.604 7.83 1.84a16.11 16.11 0 0 1 5.9 5.11l-2.11 1.49a13.55 13.55 0 0 0-3.07-3 14.243 14.243 0 0 0-4-2.06 14.536 14.536 0 0 0-4.53-.7 14.137 14.137 0 0 0-7.19 1.85 13.863 13.863 0 0 0-5.23 5.25c-3.955 6.846-1.614 15.602 5.23 19.56a14.32 14.32 0 0 0 20.89-8.14H58.24l1.68-2.6h15a16.482 16.482 0 0 1-2.71 7.77 16.75 16.75 0 0 1-14.17 7.53 16.444 16.444 0 0 1-8.51-2.28 17 17 0 0 1-6.14-6.16 16.575 16.575 0 0 1-2.28-8.54 17 17 0 0 1 5-12 16.573 16.573 0 0 1 5.47-3.64 16.924 16.924 0 0 1 6.51-1.28z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgG;